module.exports = __webpack_public_path__ + "img/book-quran.63ef0f23.svg";